import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

const components = {
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" onClick={(event) => event.stopPropagation()}>
      {children}
    </a>
  ),
};
components.a.propTypes = { href: PropTypes.string, children: PropTypes.node };

export function AnnouncementDescription({ children = "", sx, ...props }) {
  return (
    <Typography
      {...props}
      component="div"
      sx={{
        overflowWrap: "anywhere",
        "& p": { margin: "0 0 0.5em" },
        "& > :last-child": { marginBottom: 0 },
        "& ul": { listStyleType: "disc", paddingLeft: "1.5em", margin: "0.5em 0" },
        "& ol": { listStyleType: "decimal", paddingLeft: "1.5em", margin: "0.5em 0" },
        "& li > p": { margin: 0 },
        "& a": { color: "primary.main", textDecoration: "underline" },
        ...sx,
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        allowedElements={["p", "br", "strong", "em", "ul", "ol", "li", "a"]}
        unwrapDisallowed
        components={components}
      >
        {children}
      </ReactMarkdown>
    </Typography>
  );
}

AnnouncementDescription.propTypes = {
  children: PropTypes.string,
  sx: PropTypes.object,
};
